import styled from 'styled-components/macro';

import { ReactComponent as Chevron } from 'icons/Chevron.svg';

const RotatedChevron = styled(Chevron)`
  transition: transform 0.15s ease-out;
  transform: rotate(0);
  margin-left: 10px;
`;

export default RotatedChevron;
